<template>
  <div>
    <slot :data="cData" :loading="loading" :empty="empty"></slot>
    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <!-- <div slot="spinner">Loading...</div> -->
      <error-message
        slot="no-more"
        :text="text"
        v-if="$route.name != 'yun.mygame'"
      />
      <div slot="no-more" v-if="$route.name == 'yun.mygame'">
        <div
          style="
            color: #999999;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
          已经到底啦~
        </div>
      </div>
      <error-message
        slot="no-results"
        :text="text2"
        v-if="url != 'order/order-list' && url != 'order/up-order-list'"
      />
      <div
        class="order_empty"
        slot="no-results"
        v-if="url == 'order/up-order-list'"
      >
        <img src="../assets/order/order_empty.png" alt="" />
        <div class="e_words">您还没有相关订单</div>
      </div>
      <div
        class="order_empty"
        slot="no-results"
        v-if="url == 'order/order-list'"
      >
        <img src="../assets/order/order_empty.png" alt="" />
        <div class="e_words">您还没有相关订单</div>
        <van-button
          @click="$router.push({ name: 'yunbuy', query: { type: 'VIP' } })"
          >去购买云手机</van-button
        >
      </div>
    </infinite-loading>
  </div>
</template>

<script type="text/javascript">
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "water-scroll",
  data() {
    return {
      height: 0,
      page: 1,
      data: [],
      loading: 0,
      infiniteId: 1,
      btnFlag: false,
    };
  },
  //返回时要修改
  props: {
    limit: {
      type: Number,
      default: 10,
    },
    url: {
      type: String,
      required: true,
    },
    params: {
      type: Object,
      default() {
        return {};
      },
    },
    text: {
      type: String,
      default: "没有更多数据~",
    },
    text2: {
      type: String,
      default: "暂无数据",
    },
    computeData: Function,
  },
  computed: {
    sendData() {
      return {
        ...this.params,
        page: this.page,
        limit: this.limit,
      };
    },
    trigger() {
      return this.url + "?" + this.$QueryString.stringify(this.params);
    },
    cData() {
      return (
        (typeof this.computeData === "function"
          ? this.computeData(this.data)
          : this.data) || []
      );
    },
    empty() {
      return !this.cData.length;
    },
  },

  mounted() {},
  methods: {
    norepeat(arr) {
      for (var i = 0; i < arr.length - 1; i++) {
        for (var j = i + 1; j < arr.length; j++) {
          if (arr[i].id === undefined) continue;
          if (arr[i].id == arr[j].id) {
            arr.splice(j, 1);
            j--;
          }
        }
      }
      return arr;
    },
    addDate(arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].serviceTime && arr[i - 1].serviceTime) {
          if (arr[i - 1].serviceTime != arr[i].serviceTime) {
            arr.splice(i, 0, { date: arr[i].serviceTime });
          }
        }
      }
      return arr;
    },
    addDuty(arr) {
      for (var i = 1; i < arr.length; i++) {
        if (arr[i].role && arr[i - 1].role) {
          if (arr[i - 1].role != arr[i].role) {
            arr.splice(i, 0, { duty: arr[i].role });
          }
        }
      }
      return arr;
    },
    infiniteHandler($state) {
      this.loading++;
      this.$Ajax(this.url, this.sendData)
        .then((rs) => {
          this.page++;
          if (
            rs &&
            rs.code == 1 &&
            rs.data.data instanceof Array &&
            rs.data.data.length > 0
          ) {
            this.$emit("on-fetch", {
              data: rs.data.data,
              total: rs.data.total,
            });
            this.data.push(...rs.data.data);
            this.data = this.norepeat(this.data);
            this.$emit("getAllData", this.data);
            $state.loaded();
            if (this.page == 2) {
              this.$emit("emit", true);
            }
          } else {
            this.$emit("emit", false);
          }
          if (
            rs.data &&
            (!rs.data.totalPage || rs.data.page >= rs.data.totalPage)
          ) {
            $state.complete();
          }
        })
        .finally(() => {
          this.loading--;
        });
    },
    refresh() {
      this.page = 1;
      this.data = [];
      this.infiniteId++;
    },
    modifyFocus(index, flag) {
      this.data[index].focusFlag = flag;
    },
    ModifyShield(index, flag) {
      this.data[index].shieldFlag = flag;
    },
  },
  watch: {
    trigger: "refresh",
    empty: {
      immediate: true,
      handler(e) {
        if (this.url == "order/order-list") {
          this.$bus.$emit("empty", e);
        }
      },
    },
  },
  components: {
    InfiniteLoading,
  },
};
</script>

<style lang="less" scoped>
.order_empty {
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 11.8rem;
    height: 11.8rem;
  }
  .e_words {
    font-size: 0.9rem;
    color: #000;
    margin-bottom: 2.65rem;
  }
  .van-button {
    width: 11.6rem;
    height: 2.2rem;
    color: #fff;
    background: linear-gradient(270deg, #6714cc 0%, #286ff8 100%);
    border-radius: 10rem;
  }
}
</style>
